import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { PageHeader } from "../components/AppLayout";
import { Check, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { useBrand, COLORES } from "../context/BrandContext";

export default function Configuracion() {
  const { brand, update, reset } = useBrand();

  return (
    <div>
      <PageHeader
        titulo="Configuración — Se adapta a tu inmobiliaria"
        descripcion="Marca blanca: cambiá el nombre, el monograma y el color principal. Toda la app lo toma al instante, sin tocar una línea de código."
      >
        <Button variant="outline" className="rounded-md" data-testid="settings-reset" onClick={() => { reset(); toast.success("Configuración restablecida a Palermo Sur Propiedades."); }}>
          <RotateCcw className="mr-1.5 h-4 w-4" /> Restablecer
        </Button>
      </PageHeader>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-6">
          <Card className="p-6 rounded-lg border-slate-200 shadow-sm">
            <h3 className="text-base font-semibold text-slate-900 mb-4">Identidad</h3>
            <div className="space-y-4">
              <div>
                <Label htmlFor="nombre" className="text-sm">Nombre de la inmobiliaria</Label>
                <Input
                  id="nombre"
                  value={brand.nombre}
                  onChange={(e) => update({ nombre: e.target.value })}
                  className="rounded-md mt-1.5"
                  data-testid="settings-agency-name-input"
                />
              </div>
              <div>
                <Label htmlFor="monograma" className="text-sm">Monograma (iniciales para el logo)</Label>
                <Input
                  id="monograma"
                  value={brand.monograma}
                  maxLength={4}
                  onChange={(e) => update({ monograma: e.target.value.toUpperCase() })}
                  className="rounded-md mt-1.5 w-32"
                  data-testid="settings-monogram-input"
                />
                <p className="text-xs text-slate-400 mt-1">Se usa como logo en la barra lateral. Máximo 4 caracteres.</p>
              </div>
            </div>
          </Card>

          <Card className="p-6 rounded-lg border-slate-200 shadow-sm">
            <h3 className="text-base font-semibold text-slate-900 mb-4">Color principal</h3>
            <div className="flex flex-wrap gap-3" data-testid="settings-color-picker">
              {COLORES.map((c) => (
                <button
                  key={c.hex}
                  onClick={() => update({ color: c.hex })}
                  data-testid={`settings-color-${c.hex.replace("#", "")}`}
                  className={`flex items-center gap-2 rounded-md border px-3 py-2 transition-all ${
                    brand.color === c.hex ? "border-slate-900 ring-1 ring-slate-900" : "border-slate-200"
                  }`}
                >
                  <span className="h-6 w-6 rounded-md" style={{ backgroundColor: c.hex }}>
                    {brand.color === c.hex && <Check className="h-6 w-6 p-1 text-white" />}
                  </span>
                  <span className="text-sm text-slate-700">{c.nombre}</span>
                </button>
              ))}
            </div>
            <div className="mt-4 flex items-center gap-3">
              <Label className="text-sm">Color personalizado</Label>
              <input
                type="color"
                value={brand.color}
                onChange={(e) => update({ color: e.target.value })}
                className="h-9 w-16 rounded-md border border-slate-200 cursor-pointer"
                data-testid="settings-custom-color"
              />
              <span className="text-sm text-slate-500 font-mono">{brand.color}</span>
            </div>
          </Card>
        </div>

        {/* Vista previa en vivo */}
        <Card className="p-6 rounded-lg border-slate-200 shadow-sm h-fit">
          <h3 className="text-base font-semibold text-slate-900 mb-4">Vista previa en vivo</h3>
          <div className="rounded-md border border-slate-200 overflow-hidden">
            <div className="flex items-center gap-3 px-4 py-3 border-b border-slate-100">
              <div className="flex h-9 w-9 items-center justify-center rounded-md text-sm font-bold text-white" style={{ backgroundColor: brand.color }}>
                {brand.monograma}
              </div>
              <div>
                <p className="text-sm font-semibold text-slate-900">{brand.nombre}</p>
                <p className="text-xs text-slate-500">Gestión inmobiliaria</p>
              </div>
            </div>
            <div className="p-4 space-y-3">
              <div className="rounded-md px-3 py-2 text-sm font-medium text-white" style={{ backgroundColor: brand.color }}>
                Botón principal
              </div>
              <div className="rounded-md px-3 py-2 text-sm font-medium" style={{ backgroundColor: brand.color + "16", color: brand.color }}>
                Elemento activo
              </div>
              <p className="text-sm" style={{ color: brand.color }}>Texto con color de marca</p>
            </div>
          </div>
          <p className="mt-4 text-xs text-slate-400">
            Los cambios se guardan en el navegador y se aplican a toda la app al instante.
          </p>
        </Card>
      </div>
    </div>
  );
}
